<template>
  <v-list-item v-if="user && list" three-line>
    <v-list-item-content>
      <v-list-item-title>Zuständiger VB</v-list-item-title>
    </v-list-item-content>
    <v-list-item-content>
      <v-list-item-title>
        {{ user.company.name }}
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ user.first_name }}
        {{ user.last_name }}
      </v-list-item-subtitle>
      <v-list-item-subtitle
        v-if="user.user.email"
      >
        E-Mail: {{ user.user.email }}
      </v-list-item-subtitle>
      <v-list-item-subtitle
        v-if="user.user.phone_number_1 && user.user.phone_number_1 != 'NULL'"
      >
        Tel.: {{ user.user.phone_number_1 }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
  <v-row v-else-if="user&& !list">
    <v-col cols="12">
      <v-divider />
    </v-col>
    <v-col cols="12" lg="4">
      <v-list-item-title>
        Zuständiger VB
      </v-list-item-title>
    </v-col>
    <v-col>
      <v-list-item class="pa-0">
        <v-list-item-content class="pa-0">
          <b>
            {{ user.company.name }}
          </b>
          <v-list-item-subtitle>
            {{ user.first_name }}
            {{ user.last_name }}
          </v-list-item-subtitle>
          <v-list-item-subtitle
            v-if="user.user.email"
          >
            E-Mail: {{ user.user.email }}
          </v-list-item-subtitle>
          <v-list-item-subtitle
            v-if="user.user.phone_number_1 && user.user.phone_number_1 != 'NULL'"
          >
            Tel.: {{ user.user.phone_number_1 }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
export default {
   props: {
      offerData: {
         type: Object,
         required: true,
      },
      list: {
         type: Boolean,
         required: false,
         default: false
      }
   },
   data () {
      return {
         user: null,
      }
   },
   mounted: function () {
      this.loadTeam()
   },
   methods: {
      loadTeam () {
         axios.get(
            this.route('offerData.performer.info', { offerData: this.offerData.id })
         ).then(response => {
            if (response.data.user) {
               this.user = response.data.user
               console.log(this.user)
            }
         })
      }
   }
}
</script>
